<template>
  <div class="compute" v-if="locale.floating">
    <template v-if="loadingState">
      <div class="spinner">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
            <g id="triangle8">
                <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
            </g>
            <g id="triangle7">
                <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
            </g>
            <g id="triangle6">
                <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
            </g>
            <g id="triangle5">
                <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
            </g>
            <g id="triangle4">
                <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
            </g>
            <g id="triangle3">
                <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
            </g>
            <g id="triangle2">
                <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
            </g>
            <g id="triangle1">
                <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
            </g>
        </svg>
      </div>
    </template>

    <template v-if="!loadingState">
    <div class="content-headline">
      <div class="content-headline__wrapper">
        <h1>{{locale.floating.floatingips}}</h1>
        <div class="content-headline__control-buttons">
          <a href="#" v-on:click="requestNewFloating">
            <button class="button">{{locale.floating.buttonNewIP}}</button>
          </a>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="responsive">
        <thead>
        <tr>
          <th scope="col">{{locale.floating.ip}}</th>
          <th scope="col">{{locale.floating.id}}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="float in floating">
          <tr :key="float.id">
            <td data-label="IP">{{float.floatingIpAddress}}</td>
            <td data-label="Server">{{float.id}}</td>
            <td data-label="Action">
              <a href="#" v-on:click="deleteFloating(float.id)">
                <span class="actions-icon actions-icon--trash"></span>
              </a>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Floating',
  computed: {
    ...mapState(['locale']),
    ...mapState({
      floating: state => state.floating.floating,
      loadingState: state => state.loadingState
    })
  },
  data: function () {
    return {
      interval: null
    }
  },
  mounted () {
    this.$store.dispatch('floating/getFloating', 1)
    this.interval = setInterval(function () {
      this.refresh()
    }.bind(this), 3000)
  },
  methods: {
    ...mapActions({
      deleteFloating: 'floating/deleteFloating'
    }),
    requestNewFloating: function () {
      this.$store.dispatch('floating/requestNewFloating').then((response) => {
        console.log('success')
        this.buttonText = 'Success'
        this.$store.dispatch('floating/getFloating', 0)
      }).catch((error) => {
        console.log(error)
        this.buttonText = 'Error'
      })
    },
    refresh: function () {
      this.$store.dispatch('floating/getFloating', 0)
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Floating.vue